import style from './style.scss';
import React from 'react';
import classNames from './common/classNames';

const Cell = ({ children, textClass, additionalClass, isFinalPrize }) =>
    <div className={classNames(style.panelCell, additionalClass)}>
        <div className={classNames(style.textBlock, style.textBlockParams)}>
        <span className={classNames(textClass, style.textParams, isFinalPrize)}>
            {children}
        </span>
        </div>
    </div>;

export default Cell;
